import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";

export const DeliveryAddressSelected = ({
  order,
  setTab,
  addressConfirmed,
  onConfirmAddressChange,
}) => {
  const isResidential = order.data.order.homeaddress !== "No";

  return (
    <Paper
      sx={{
        width: "100%",
        // p: 2,
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          p: 2,
        }}
      >
        <Grid size={12}>
          <Stack
            direction="row"
            spacing={2}
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Typography variant="h6">Selected address</Typography>
            <Chip
              size="small"
              icon={isResidential ? <HomeIcon /> : <BusinessIcon />}
              label={isResidential ? "Residential Address" : "Business Address"}
              color={isResidential ? "secondary" : "default"}
              variant="outlined"
            />
          </Stack>
        </Grid>
        <Grid size={12}>
          <Divider />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <TextField
            fullWidth
            size="small"
            label="Name / Company"
            value={order.data.order.name || ""}
            disabled
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <TextField
            fullWidth
            size="small"
            label="Address Line 1"
            value={order.data.order.address || ""}
            disabled
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <TextField
            fullWidth
            size="small"
            label="Address Line 2"
            value={order.data.order.address2 || ""}
            disabled
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <TextField
            fullWidth
            size="small"
            label="County"
            value={order.data.order.county || ""}
            disabled
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <TextField
            fullWidth
            size="small"
            label="City"
            value={order.data.order.city || ""}
            disabled
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <TextField
            fullWidth
            size="small"
            label="Postcode"
            value={order.data.order.postCode || ""}
            disabled
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <TextField
            fullWidth
            size="small"
            label="Country"
            value={order.data.order.country || ""}
            disabled
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid size={12}>
          <Divider textAlign="left">
            <Typography variant="caption" color="text.secondary">
              Contact Details
            </Typography>
          </Divider>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <TextField
            fullWidth
            size="small"
            label="Contact Name"
            value={order.data.order.contact || ""}
            disabled
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        {order.data.order.homeaddress === "Yes" && (
          <>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <TextField
                fullWidth
                size="small"
                label="Contact Email"
                value={order.data.order.email || ""}
                disabled
                slotProps={{
                  input: {
                    readOnly: true,
                  },
                }}
              />
            </Grid>

            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <TextField
                fullWidth
                size="small"
                label="Contact Mobile"
                value={order.data.order.mobileNo || ""}
                disabled
                slotProps={{
                  input: {
                    readOnly: true,
                  },
                }}
              />
            </Grid>
          </>
        )}
        <Grid size={12}>
          <Divider />
        </Grid>
        <Grid size={12}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <Button variant="contained" onClick={() => setTab(1)}>
              Change
            </Button>
            <FormControlLabel
              control={
                <Checkbox
                  checked={addressConfirmed}
                  onChange={(e) => onConfirmAddressChange(e.target.checked)}
                  color="primary"
                />
              }
              label="Confirm address is correct"
            />
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};
